<p-dialog [(visible)]="visibleBankTransferModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" (onHide)="closeModal()">
  <div class="dialog">
    <form [formGroup]="formBankTransfer" (ngSubmit)="onBankTransfer()">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info">
            <h2>Transferencia a otros bancos</h2>
            <p>La información es para una cuenta que esté a tu nombre: <strong>{{ request?.person.first_name | uppercase}} {{ request?.person.last_name | uppercase}}</strong>.</p>
          </div>
          <div class="dialog__form">
            <div class="form__group" [ngClass]="{'form__error': submitted && fBankTransfer['bank_name'].errors}">
              <div class="p-float-label">
                <p-dropdown [options]="country.bankList" [editable]="false" [placeholder]="'Selecciona'" id="name" optionLabel="name" optionValue="name" formControlName="bank_name"></p-dropdown>
                <label for="name">¿En qué banco tienes tu cuenta? *</label>
              </div>

              <span class="form__msgError" *ngIf="submitted && fBankTransfer['bank_name'].errors">
                <small class="p-error" *ngIf="fBankTransfer['bank_name'].getError('required')">{{ 'El banco' | required}}</small>
              </span>
            </div>

            <div class="form__group" [ngClass]="{'form__error': submitted && fBankTransfer['type'].errors}">
              <span class="form__label">¿Qué tipo de cuenta es? *</span>
              
              <div class="form__radio">
                <div class="form__radioItem" *ngFor="let account of AccountType">
                  <p-radioButton [inputId]="account.value" [value]="account.value" formControlName="type" name="type"></p-radioButton>
                  <label [for]="account.value">{{ account.label }}</label>
                </div>
              </div>

              <span class="form__msgError" *ngIf="submitted && fBankTransfer['type'].errors">
                <small class="p-error" *ngIf="fBankTransfer['type'].getError('required')">{{ 'El tipo de cuenta' | required}}</small>
              </span>
            </div>

            <div class="form__group" [ngClass]="{'form__error': submitted && fBankTransfer['number'].errors}">
              <div class="p-float-label">
                <input pInputText type="text" id="number" formControlName="number" />
                <label for="number">Coloca el número de la cuenta *</label>
              </div>

              <span class="form__msgError" *ngIf="submitted && fBankTransfer['number'].errors">
                <small class="p-error" *ngIf="fBankTransfer['number'].getError('required')">{{ 'El número de la cuenta' | required}}</small>
              </span>
            </div>
          </div>
          <div class="dialog__btn">
            <button pButton pRipple type="submit" label="Transferir dinero a mi cuenta" class="p-button-primary p-button-raised p-button-rounded w-full" [loading]="loading"></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>
